import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import Torpedo from '@wix/da-shared-react/pkg/Torpedo/DeviationTorpedo';
import LoadableDuperbrowseContext from '../../../../contexts/LoadableDuperbrowseContext';
import PostsFeed from '../../../Sections/PostsSection/_partials/PostsFeed';
import StreamPagination from '../../../Sections/_partials/StreamPagination';
import { MeasuredCookieType } from '@wix/da-shared-react/pkg/Measured'; // TODO: add new cookie type
import { SubscriptionsTierContentType } from '../../../../../types/subscriptionsSection';

const TORPEDO_DEFAULT_SIZE = {
  desktop: { width: 1024, height: 0 },
  mobile: { width: 320, height: 0 },
};
const TORPEDO_CONTAINER_SIZE = { width: 1024 };

import s from './TierContentFeed.scss';

export interface Props {
  tierContentType: SubscriptionsTierContentType;
  streamId: string;
  deviations?: PapiDeviation[];
  tier?: PapiDeviation;
  isEmpty?: boolean;
}

const TierContentFeed: React.FC<Props> = ({
  streamId,
  deviations = [],
  isEmpty,
  tierContentType,
}) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      {!isEmpty && (
        <LoadableDuperbrowseContext
          streamId={streamId}
          parent={{
            title: t('common.back'),
          }}
        >
          <BiLoggerContextProvider value={{ sectionname: tierContentType }}>
            {tierContentType === SubscriptionsTierContentType.POSTS && (
              <PostsFeed streamId={streamId} className={s['posts']} />
            )}
            {tierContentType === SubscriptionsTierContentType.DEVIATIONS && (
              <>
                <Torpedo
                  cookieType={
                    MeasuredCookieType.USER_PROFILE_GALLECTION_CONTENT
                  }
                  cookieDim={'width'}
                  defaultSize={TORPEDO_DEFAULT_SIZE}
                  container={TORPEDO_CONTAINER_SIZE}
                  items={deviations}
                  enableScrollVisibilityOptimisation
                />
                <StreamPagination streamId={streamId} />
              </>
            )}
          </BiLoggerContextProvider>
        </LoadableDuperbrowseContext>
      )}
    </div>
  );
};
TierContentFeed.displayName = 'TierContentFeed';

export default TierContentFeed;
